var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"molecule-file-upload"},[_c('h3',{staticClass:"molecule-file-upload__title"},[_vm._v(_vm._s(_vm.title))]),_c('AtomFileInput',{attrs:{"accept":_vm.accept,"placeholder":_vm.placeholder,"selected-file":_vm.selectedFile,"disabled":_vm.disabled},on:{"file-selected":_vm.handleFileSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }